module.exports = __webpack_public_path__ + "img/publicity.9a84bc23.png";